// extracted by mini-css-extract-plugin
export default {"btn":"PGkXgURk","notes":"j5_lbkhs","mobile":"mobile","description":"WcS2p_L8","text":"QO0VQ3zN","desktop":"desktop","link":"ruTZMZGq","close":"sFrrTztL","more":"j8_gijId"};